<template>
  <express-fee-promotion-details :is-edit='true'>
  </express-fee-promotion-details>
</template>

<script>
import ExpressFeePromotionDetails from '../ExpressFeePromotionDetails'
export default {
  name: 'EditExpressFeePromotion',
  components: {
    ExpressFeePromotionDetails
  }
}
</script>

